import React, { useEffect, useGlobal } from "reactn";
import { Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import SideMenu from './layout/SideMenu';
import HeaderBar from './layout/HeaderBar';
import {
  Dashboard, UserList, RedirectComp, NotFoundPage,
  Admins, AdminDetail,
  Streams, StreamsDetail, StreamCodes, StreamCodeDetail, StreamControl,
  QuestionSet, QuestionSetDetail,
  Users, UsersDetail,
  Results, ResultDetail,
  Notifications, NotificationDetail,
  Settings
} from './pages';

const { Header, Content } = Layout;

const Admin = (props) => {
  let [token, setToken] = useGlobal('token');
  let [user] = useGlobal('user');
  let [isSmall, setIsSmall] = useGlobal('isSmall')
  let [collapsed, setCollapsed] = useGlobal('collapsed');

  useEffect(() => {
    window.onresize = () => {
      setIsSmall(window.innerWidth < 1024)
    }
  }, [setIsSmall, setToken])

  useEffect(() => {
    if (isSmall)
      setCollapsed(true)
    else
      setCollapsed(false)
  }, [isSmall, setCollapsed])

  if (!token || !user) {
    props.history.push('/login');
  }

  return (
    <Switch>
      <Layout style={{ minHeight: '100vh' }}>
        <SideMenu collapsed={collapsed} />
        <Layout className="site-layout" >
          <Header
            className="site-layout-background header"
            style={{ padding: '0 20px' }}
            theme="dark"
          >
            <HeaderBar />
          </Header>
          <Content className="main-wrap">
            <Switch>
              <Route exact path="/" component={RedirectComp} />
              <Route path="/userlist" component={UserList} />

              <Route exact path="/adminInfo" component={Dashboard} />
              <Route exact path="/settings" component={Settings} />
              <Route exact path="/admins" component={Admins} />
              <Route exact path="/admin/add" component={AdminDetail} />
              <Route exact path="/admin/edit/:id" component={AdminDetail} />

              <Route exact path="/users" component={Users} />
              <Route exact path="/users/edit/:id" component={UsersDetail} />
              <Route exact path="/users/add" component={UsersDetail} />

              <Route exact path="/questionSet" component={QuestionSet} />
              <Route exact path="/questionSet/edit/:id" component={QuestionSetDetail} />
              <Route exact path="/questionSet/add" component={QuestionSetDetail} />

              <Route exact path="/streams" component={Streams} />
              <Route exact path="/streams/edit/:id" component={StreamsDetail} />
              <Route exact path="/streams/add" component={StreamsDetail} />
              <Route exact path="/streams/codes/:id" component={StreamCodes} />
              <Route exact path="/streams/codes/:streamId/edit/:id" component={StreamCodeDetail} />
              <Route exact path="/streams/codes/:streamId/add" component={StreamCodeDetail} />
              <Route exact path="/streams/control/:id" component={StreamControl} />

              <Route exact path="/results" component={Results} />
              <Route exact path="/results/:id" component={ResultDetail} />

              <Route exact path="/notifications" component={Notifications} />
              <Route exact path="/notifications/add" component={NotificationDetail} />
              <Route exact path="/notifications/edit/:id" component={NotificationDetail} />

              <Route path='*' component={NotFoundPage} />

            </Switch>
          </Content>
        </Layout>
      </Layout>
    </Switch>
  );
};

export default Admin;
